import React, { useEffect, useState, Fragment,useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import { ArrowRight, Filter, tick } from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ModalPop from 'components/sales/modal/modal';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import Images from 'assets/images/imageData';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import FormSection from 'components/sales/formSection/formSectionNew';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import moment from 'moment';
import DatePicker from 'components/sales/datePicker/datePicker';
import Loader from 'components/sales/Loader/loader';
import { toast } from 'react-toastify';

const RaiseRenewalRequest = ({
    getPrefilledGateData,
    prefilledGateData,
    renewalRequest,
    saveRenewalRequest,
    getPrefilledRequestData,
    prefilledRequestData,
    getGateBasePrices,
    basePrices,
    match,
    history
}) => {
    const inputs = {
        gate_data: null,
        contract_length: '',
        payment_term_type: '',
        payment_term_name: '',
        // live_date: '',
        // expiry_date:'',
        contract_type: '',
        amc_type: '',
        milestones: null,
        additional_cost: 0,
        increament_data:null,
        site_id: match.params.site_id,
        additional_cost_remarks:''
    };

const [isLoading, setIsLoading] = useState(false);
const [formData,setFormData] = useState(inputs);
const [minDateIndex, setMinDateIndex] = useState(null);
const [agreementEndDate, setAgreementEndDate] = useState(null);
const [agreementLength, setAgreementLength] = useState(null);
const [inputList, setInputList] = useState([]);
const [duration, setDuration] = useState([{id:"Yearly",name:"Yearly"}]);
const [month, setMonth] = useState(1);
const [increament, setIncreamentData] = useState();
const [contract_length, setContractLength] = useState(1);
const [amount, setAmount] = useState(null);
const [gateData, setGateData] = useState([]);
const [paymentTerms,setPaymentTerms] = useState([]);
const [subscriptionAmount, setSubscriptionAmount] = useState(null);
const [contractType, setContractType] = useState('');
const [amcType, setAmcType] = useState('');
const [additionalCost,setAdditionalCost] = useState(0);
const [isModal, setIsModal] = useState(false);
const [message,setMessage] = useState('');
const [isSuccess, setIsSuccess] = useState(false);
const { baseUrl } = useContext(BaseUrl);
const [incrementTypes,setIncrementTypes]=useState([
                                            { id: 'no', name: 'no' },
                                            { id: 'nonUniform', name: 'Non-Uniform' },
                                            { id: 'flat', name: 'Flat Value' },
                                            { id: 'percentage', name: 'Percentage' },
                                        ]);
const [selectedIncrement,setSelectedIncrement]=useState('');
const [allGateTypes,setAllGateTypes]=useState([])
const [lastPaymentTerm,setLastPaymentTerm]=useState({
  id:'',
  name:''
})
useEffect(() => {
    if (prefilledGateData && prefilledGateData.gate_data  && prefilledGateData.gate_data.length > 0) {
        setGateData(
            prefilledGateData.gate_data.map(item => ({
                id: item.id || '',
                name: item.name ||'',
                amc: '',
                hardware_price:'',
                software_price:''
                // price: item.price || 0,
                // software_price:item.software_price||0,
                // capex_price_non_comp: item.capex_price_non_comp || 0,
                // capex_software_price_non_comp:item.capex_software_price_non_comp||0,
                // capex_price_comp: item.capex_price_comp || 0,
                // capex_software_price_comp:item.capex_software_price_comp||0
            }))
        );
    }
    if (prefilledGateData && prefilledGateData.payment_terms && prefilledGateData.payment_terms.length > 0) {
        setPaymentTerms(
            prefilledGateData.payment_terms.map(item => ({
                id: item.id,
                name : item.name
            }))
        );
    }
    if (prefilledGateData && prefilledGateData.gate_setup_types && prefilledGateData.gate_setup_types.length > 0) {
      setAllGateTypes(
        prefilledGateData.gate_setup_types.map(item => ({
            id: item.id,
            name : item.name,
            // price: item.price,
            // software_price:item.software_price,
            // capex_price_non_comp: item.capex_price_non_comp,
            // capex_software_price_non_comp:item.capex_software_price_non_comp,
            // capex_price_comp: item.capex_price_comp,
            // capex_software_price_comp:item.capex_software_price_comp
        }))
      );
    }
    if (prefilledGateData && prefilledGateData?.last_contract_payment_term_id) {

      setLastPaymentTerm(
        {
          id:prefilledGateData?.last_contract_payment_term_id,
          name:prefilledGateData?.last_contract_payment_term_name
        }
      )
    }
}, [prefilledGateData]);

useEffect(() => {
  if(lastPaymentTerm?.id !='' && lastPaymentTerm?.name !='') {
      // setFormData([
      //   ...formData,{
      //     payment_term_type:lastPaymentTerm?.id,
      //     payment_term_name:lastPaymentTerm?.name
      //   }]);
      setFormData(formData => ({
        ...formData,
        payment_term_type:lastPaymentTerm?.id,
        payment_term_name:lastPaymentTerm?.name
      }));
  }
}, [lastPaymentTerm]);

useEffect(() => {
    if(gateData!=undefined && gateData!=null) {
        const totalGatePrice = gateData.reduce((acc, item) => acc + parseInt(item.price || 0)+parseInt(item.software_price||0), 0);
        const totalAmount = totalGatePrice + parseInt(formData.additional_cost || 0);
        setSubscriptionAmount(totalAmount);
    }
}, [gateData, formData.additional_cost]);

// const handleGateInputChange = (index, field, value) => {
//     const updatedFormData = [...gateData];
//     updatedFormData[index] = {
//         ...updatedFormData[index],
//         [field]: value,
//     };
//     setGateData(updatedFormData);
// };
const handleGateInputChange = (index, fieldsToUpdate) => {
  // const updatedFormData = [...gateData];
  // console.log(updatedFormData)
  // updatedFormData[index] = {
  //     ...updatedFormData[index],
  //     ...fieldsToUpdate, // Merge multiple fields at once
  // };
  // console.log(updatedFormData)
  // setGateData(updatedFormData);

  setGateData(prevGateData => {
    const updatedFormData = [...prevGateData];
    updatedFormData[index] = {
        ...updatedFormData[index],
        ...fieldsToUpdate, // Merge multiple fields at once
    };
    return updatedFormData;
});
};

const addGate = () => {
  setGateData([...gateData, { 
    id: '',
    name: '',
    amc: '',
    hardware_price: 0,
    software_price: 0,
  }]);
};

const removeGate = (index) => {
  if (gateData.length > 1) {
      const updatedGateData = gateData.filter((_, i) => i !== index);
      setGateData(updatedGateData);
  }
};
useEffect(() => {
    (async () => {
        setIsLoading(true);
        if(match.params.site_id != undefined) {
            await getPrefilledGateData(match.params.site_id);
            await getPrefilledRequestData(match.params.site_id);
        }
        setIsLoading(false);
    })()
  },[match.params.site_id]);

useEffect(()=>{
    setIsLoading(true);
    if(prefilledRequestData!=null && prefilledRequestData!=undefined && Object.keys(prefilledRequestData).length != 0){
          const termMultipliers = {
            2: 1,   // Monthly (base price)
            3: 3,   // Quarterly
            4: 6,   // Half Yearly
            5: 12   // Yearly
        };

        const paymentTermId = prefilledRequestData.payment_term_type;
        const multiplier = termMultipliers[paymentTermId] || 1;

        setFormData({
            // live_date: prefilledRequestData.live_date,
            // expiry_date: prefilledRequestData.expiry_date,
            // gate_data: prefilledRequestData.gate_data,
            contract_length: prefilledRequestData.contract_length,
            payment_term_type: prefilledRequestData.payment_term_type,
            payment_term_name: prefilledRequestData.payment_term_name,
            contract_type: prefilledRequestData.contract_type,
            amc_type: prefilledRequestData.amc_type,
            additional_cost: prefilledRequestData.additional_cost,
            additional_cost_remarks:prefilledRequestData?.additional_cost_remarks||'',
            increament_data:prefilledRequestData.increament_data,
            site_id: match.params.site_id,
        });
        setContractType(prefilledRequestData.contractTypeName)
        setAmcType(prefilledRequestData.amcTypeName)
        setAgreementLength(prefilledRequestData.contract_length)
        setAdditionalCost(prefilledRequestData.additional_cost)
        // setGateData(prefilledRequestData.gate_data)
        setIncreamentData(prefilledRequestData?.increament_data?.inc)
        // setInputList(prefilledRequestData?.increament_data?.input)
        if(prefilledRequestData?.increament_data?.inc?.increament_type!=null && prefilledRequestData?.increament_data?.inc?.increament_type!=undefined){
          setSelectedIncrement(incrementTypes.find(item => item.id == prefilledRequestData?.increament_data?.inc?.increament_type)?.name);
        }
        const adjustedGateData = prefilledRequestData.gate_data.map(gate => {
            const adjustedGate = { ...gate };
            
            if (adjustedGate.hardware_price) {
                adjustedGate.hardware_price /= multiplier;
            }
            if (adjustedGate.software_price) {
                adjustedGate.software_price /= multiplier;
            }
    
            return adjustedGate;
        });
    
        setGateData(adjustedGateData);
  
    }
    setIsLoading(false);
},[prefilledRequestData])

// useEffect(() => {
//     (async () => {
//         setIsLoading(true);
//         if(match.params.site_id != undefined) {
//                 await getPrefilledRequestData(match.params.site_id);
//             }
//         setIsLoading(false);
//     })()
// },[match.params.site_id]);
  
  const validateForm = () => {
    // Check other fields
    const requiredFields = ['contract_length', 'contract_type'];
    if(formData.contract_type=='7'){
      requiredFields.push('payment_term_type')
    }
    for (const field of requiredFields) {
      if (!formData[field]) {
        toast.error(`Please fill the ${field.replace(/_/g, ' ')} field.`);
        return false; // Halt submission
      }
    }
    
    for (const gate of formData.gate_data) {
        if(gate.hardware_price==null || gate.hardware_price==undefined || gate.hardware_price=='' || !gate.hardware_price){
          toast.error("Please fill the Hardware Price");
          return false;
        }
        if(isNaN(Number(gate.hardware_price))){
          toast.error("Hardware Price must be a valid number");
          return false;
        }
        if(Number(gate.hardware_price) <= 0){
          toast.error("Hardware Price cannot be 0 or negative");
          return false;
        }
        if(formData.contract_type == '16' && (gate.amc==null || gate.amc==undefined || gate.amc=='' || !gate.amc)){
          toast.error("Please fill the AMC Type");
          return false;
        }
        if(formData.contract_type == '16' && gate.software_price != 0 && (gate.software_price==null || gate.software_price==undefined || gate.software_price=='')){
          toast.error("Please fill the Software Price");
          return false;
        }
        if(formData.contract_type == '16' && (isNaN(Number(gate.software_price)) || Number(gate.software_price)<0)){
          toast.error("Software Price must be a valid number");
          return false;
        }
        // if(formData.contract_type == '16' && Number(gate.software_price) <= 0){
        //   toast.error("Software Price cannot be 0 or negative");
        //   return false;
        // }
    }

    // Check additional_cost
    if (isNaN(Number(formData.additional_cost))) {
      toast.error("Please enter a valid additional cost.");
      return false; // Halt submission
    }

    // if (formData.additional_cost!='0' && (formData.additional_cost_remarks==undefined || formData.additional_cost_remarks==null)) {
    //   toast.error("Please enter a valid remark for additional cost.");
    //   return false; // Halt submission
    // }
    if(formData.contract_type=='7'){
        if(formData?.increament_data?.inc?.increament_type== 'flat' || formData?.increament_data?.inc?.increament_type == 'percentage'){
            if(!formData.increament_data.inc.duration || !formData.increament_data.inc.increament_amount){
                toast.error("Please provide valid increament duration and amount.");
                return false;
            }
        }else if(formData?.increament_data?.inc?.increament_type=='nonUniform'){
            if (!Array.isArray(formData.increament_data.input) || formData.increament_data.input.length === 0) {
                toast.error("Please provide valid increament data.");
                return false; // Halt submission
            }
        }else if(formData?.increament_data?.inc?.increament_type==''||formData?.increament_data?.inc?.increament_type==null||formData?.increament_data?.inc?.increament_type==undefined){
            toast.error("Please select Increment type.");
            return false;
        }
    }
    return true;
};

  const handleSubmit = (e) => {
    e.preventDefault();
    // Validate the form before submission
    if (!validateForm()) {
      return; // If validation fails, halt submission
    }
    (async () => {
        const res = await saveRenewalRequest(formData);
        if (res?.status === true) {
          setIsSuccess(true);
          setMessage("Request Raised Successfully");
          setIsModal(true);
        } else {
          if(res?.status==false && res?.response?.status==400){
            toast.error(res?.response?.message)
            return false;
          }
          // setIsSuccess(false);
          // setMessage('Something went wrong!');
          // setIsModal(true);
        }
    })()
  };

  const handleContractTypeChange = async (contractType) => {
    // Update the main form's contract type
    setIsLoading(true)
    setFormData(prevFormData => ({
        ...prevFormData,
        contract_type: contractType
    }));

    // Update prices for each item only if contract type affects it
    gateData.forEach((item, index) => {
        const amcType = item.amc || '';
        if (item.id && contractType) {
            getGateBasePrices(item.id, contractType, amcType).then(prices => {
                handleGateInputChange(index, {
                    hardware_price: prices?.hardware_price || 0,
                    software_price: prices?.software_price || 0
                });
            });
        }
    });
    setIsLoading(false)
};
  const handleInputChange = (e,index,name)=>{
    const list = [...inputList];
    list[index][name] = e.target.value ?? 0;
    setInputList(list);
  };

  // const setAgreementEndLength = (val) => {
  //   if (val != 'Invalid date') {
  //     var dateParts = val.split("-");
  //     var dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
  //     var newDate = new Date(dateObject.setMonth(dateObject.getMonth()+parseInt(agreementLength)));
  //     setAgreementEndDate(newDate);
  //     let formatDate = "";
  //     if (newDate) { 
  //       var dd = newDate.getDate();
  //       var mm = newDate.getMonth()+1; 
  //       var yyyy = newDate.getFullYear();
  //       if(dd<10) {
  //           dd='0'+dd;
  //       } 
  //       if(mm<10) {
  //           mm='0'+mm;
  //       } 
  //       formatDate = dd+'-'+mm+'-'+yyyy; 
  //     }
  //     setFormData({
  //       ...formData,
  //       live_date: val,
  //       expiry_date: formatDate,
  //     });

  //   } else {
  //     setAgreementEndDate(null);
  //   }
  // };

  // useEffect(() => {
  //   if (formData?.live_date && formData?.contract_length) {
  //     setAgreementEndLength(formData?.live_date);
  //   }
  // }, [formData?.contract_length,formData?.live_date]);

  const handleFormData = () => {
    // inc['input'] = inputList;
    if (inputList && gateData) {
      
      if (increament?.increament_type == 'flat' || increament?.increament_type == 'percentage') {
        const incData = {
          duration: increament?.duration,
          value: increament?.increament_amount
        };

        if (
          increament?.duration && 
          increament?.increament_amount) {
            setFormData(formData => ({
                ...formData, // Spread the previous formData state
                increament_data: {
                    inc: increament,  // Assign the increment data
                    input: inputList, // Assign the inputList
                },
                gate_data: gateData
            }));
        } else {
            setFormData(formData => ({
                ...formData, // Spread the previous formData state
                increament_data: {
                    inc: increament,  // Assign the increment data
                    input: [], // Assign the inputList
                },
                gate_data: gateData
            }));
        }
      } else {
        setFormData(formData => ({
            ...formData, // Spread the previous formData state
            increament_data: {
                inc: increament,  // Assign the increment data
                input: inputList, // Assign the inputList
            },
            gate_data: gateData
        }));
      }
    } else {
        setFormData(formData => ({
            ...formData, // Spread the previous formData state
            increament_data: null,
            gate_data: gateData
        }));
    }
  };

useEffect(() => {
  handleFormData();
}, [inputList,increament,gateData]);

const handleModalHide = () => {
    history.push(`${baseUrl}/contract-expiry`);
    setIsModal(false);
};

useEffect(() => {
    if(subscriptionAmount && formData.contract_length && formData.payment_term_type){
        setAmount(subscriptionAmount);
        setContractLength(formData.contract_length);
        if(formData?.payment_term_type == 3){
            setMonth(3); //quarter
        }else if(formData?.payment_term_type == 4){
            setMonth(6); // half
        }
        else if(formData?.payment_term_type == 5){
            setMonth(12); // 1 year
        }
        else{
            setMonth(1); // month
        }
    }
},[subscriptionAmount,formData.contract_length,formData.payment_term_type]);

const handlePaymentTermChange = async (paymentTerm) => {
  // Update the main form's payment term type
  setFormData(prevFormData => ({
      ...prevFormData,
      payment_term_type: paymentTerm.id,
      payment_term_name: paymentTerm.name
  }));


  // gateData.forEach((item, index) => {
  //     const amcType = item.amc || '';
  //     if (item.id && formData.contract_type) {
  //         getGateBasePrices(item.id, formData.contract_type, amcType, paymentTerm.id).then(prices => {
  //             handleGateInputChange(index, {
  //                 hardware_price: prices?.hardware_price || 0,
  //                 software_price: prices?.software_price || 0
  //             });
  //         });
  //     }
  // });
};

useEffect(() => {
  setIsLoading(true)
  if(increament != null && increament.increament_type == 'nonUniform'){
    const list = [...inputList];
    let updatedList = [];

    if (contract_length == undefined) {
      setContractLength(formData?.contract_length);
    }

    const totalIterations = Math.ceil(Number(contract_length) / month);

    // Generate the new list based on contract_length and month
    updatedList = [...Array(totalIterations)].map(() => ({
      subscription_amounts: subscriptionAmount
    }));

    // Set the new list once
    setInputList(updatedList);

  } else {
    // const list = [...inputList];
    // list.splice(0, );
    // setInputList(list)
    setInputList([]);
  }

  setIsLoading(false)
},[increament,subscriptionAmount,contract_length,month,formData.payment_term_type]);

// useEffect(()=>{
//   (async () => {
//     setIsLoading(true);
    
//     setIsLoading(false);
//   })()
// },[]);

  const incrementBody = () =>{
    if(increament != null && increament.increament_type == 'nonUniform'){
      return (
        <>
        {/* {month}{contract_length}{subscription_amount} */}
        {inputList.map((e, index) => (

          <div key={index}>

              <div className="col-12">
              <label> {localization.installmentAmt+` `+(index+1)+` In ₹`}<span style={{ color: 'red' }}>*</span>
              </label>
              
              <input
                  className="form-control"
                  name="subscription_amounts"
                  // placeholder={localization.installationCharge}
                  value={e.subscription_amounts}
                  onChange={e => handleInputChange(e, index,'subscription_amounts')}
                  required
                />
              </div>
              </div>
         
        )
        )}
       
        </>
      );
    }else if(increament != null && (increament.increament_type == 'flat' || increament.increament_type == 'percentage')){
      return (
        <>
          <div className="col-6">

            <DropDownInput
              label={localization.duration}
              data={duration}
              required
              errorMsg={localization.requiredDuration}
              getIdValue={(val) =>{
                setIncreamentData({
                  ...increament,
                  duration: val.id,
                });
                // handledropDownChange(val,i,'payment_mode');
                }
              }
              value={increament?.duration}
              isStarRequired={true}
            />
          </div>
          <div className="col-6">
            <ConstantInput
              label={localization.increamentAmount +` ( `+ increament.increament_type +` ) `}
              required
              type='number'
              isStarRequired={true}
              errorMsg={localization.requiredIncAmt}
              handleChange={(val) =>{
                const numericValue = val.replace(/[^0-9]/g, '');
                setIncreamentData({ ...increament, increament_amount: numericValue });
              }}
              value={increament?.increament_amount}
            />
          </div>
        </>
      );
    }
   
  };

  const headerBtns = () => {
    return (
      <Fragment>
        <Button
          onClick={handleSubmit}
          className="filter-hamburger btn btn-transparent"
        >
          <img src={Images?.Filter} alt="" />
          {localization.submit}
        </Button>
      </Fragment>
    );
  };

  const handleGateSelection = async (selectedGate, index) => {
    const selectedGateData = allGateTypes.find(gate => gate.id === selectedGate.id);
    handleGateInputChange(index, {
        id: selectedGate.id,
        name: selectedGateData ? selectedGateData.name : '',
        // Uncomment these lines if you need these fields in `handleGateInputChange`
        // gate_hardware_price: selectedGateData ? selectedGateData.gate_hardware_price : '',
        // gate_software_price: selectedGateData ? selectedGateData.gate_software_price : '',
        // price: selectedGateData ? selectedGateData.price : '',
        // software_price: selectedGateData ? selectedGateData.software_price : '',
        // capex_price_non_comp: selectedGateData ? selectedGateData.capex_price_non_comp : '',
        // capex_price_comp: selectedGateData ? selectedGateData.capex_price_comp : '',
        // capex_software_price_comp: selectedGateData ? selectedGateData.capex_software_price_comp : ''
    });
    if (selectedGateData && formData.contract_type != "") {
        const amcType=formData?.gate_data?.[index]?.amc??''
        const paymentTerm=formData?.payment_term_type;
        const res=await getGateBasePrices(selectedGateData.id, formData.contract_type, amcType,paymentTerm);
        handleGateInputChange(index, { 
                                    hardware_price: res?.hardware_price||0,
                                    software_price: res?.software_price||0
                                  })
    }
};
const handleAmcTypeChange = async (index, amcType) => {
  handleGateInputChange(index, { amc: amcType });

  const contractType = formData.contract_type;
  const selectedGate = gateData[index];
  const paymentTerm=formData?.payment_term_type;

  if (contractType && selectedGate?.id) {
      const prices = await getGateBasePrices(selectedGate.id, contractType, amcType,paymentTerm);
      
      handleGateInputChange(index, {
          hardware_price: prices?.hardware_price || 0,
          software_price: prices?.software_price || 0
      });
  }
};
return (
    <Layout
      title={'Raise Contract Renewal Request'}
      Buttons={headerBtns}
      isLoading={isLoading}
      isGoback
    >
      <FormSection title={'Raise Contract Renewal Request'}>
        <div className="row">
        <div className='col-md-6'>
            <DropDownInput
            data={[
                {id: '7', name: "Rental"},
                {id: '16',name: "AMC"}
            ]}
            label={localization.contractType}
            required
            isStarRequired={true}
            errorMsg={'Contract Type is required'}
            getIdValue={(val) =>{
              handleContractTypeChange(val.id)
                // setFormData({
                // ...formData,
                // contract_type: val.id,
                // })
                // setBasePrices(val.id)
              }
            }
            value={contractType}
            />
        </div>
          <div className='col-md-6'>
              <DropDownInput
              data={paymentTerms}
              label={localization.paymentTerms}
              required
              isStarRequired={true}
              errorMsg={localization.requiredpaymentTerms}
              getIdValue={(val) =>
                handlePaymentTermChange(val)
                  // setFormData({
                  // ...formData,
                  // payment_term_type: val.id,
                  // })
              }
              value={formData.payment_term_name}
              />
          </div>
        {/* <div className='col-md-6'>
            <DropDownInput
            data={[
                {id: 'comp', name: "Comprehensive"},
                {id: 'nonComp',name: "Non - Comp"}
            ]}
            label={'AMC Type'}
            required
            isStarRequired={true}
            errorMsg={'AMC Type is required'}
            getIdValue={(val) =>
                setFormData({
                ...formData,
                amc_type: val.id,
                })
            }
            value={amcType}
            />
        </div> */}
        <div className='col-md-6'>
            <ConstantInput
                label={localization.totalContract}
                required
                isStarRequired={true}
                errorMsg={localization.requiredtotalContract}
                handleChange={(val) => {
                setFormData({
                    ...formData,
                    contract_length: val,
                });
                setAgreementLength(val);
                }}
                value={formData.contract_length}
                type="number"
            />
        </div>
        </div>
        </FormSection>
        {gateData && allGateTypes && formData.contract_type && formData.payment_term_type ? (
        <FormSection title={'Gate and Hardware Details'}>
        <div className="row px-3"> {/* Add padding to align the form */}
        {gateData.map((item, index) => (
            <div className="row align-items-center mb-3" key={index} style={{ borderBottom: '1px solid #e9ecef', paddingBottom: '15px' }}>
                {/* Gate/Hardware Type Dropdown */}
                <div className="col-md-3 col-sm-3">
                    <DropDownInput
                        data={allGateTypes.map(gate => ({ id: gate.id, name: gate.name }))}
                        label="Gate/Hardware Type"
                        required
                        isStarRequired
                        errorMsg="Gate/Hardware Type is required"
                        getIdValue={(selectedGate) =>
                          handleGateSelection(selectedGate,index)
                        }
                        value={item.name}
                    />
                </div>

                {/* AMC Type Dropdown */}
                <div className="col-md-2 col-sm-2">
                    <DropDownInput
                        data={[
                            { id: 'comp', name: "Comprehensive" },
                            { id: 'nonComp', name: "Non - Comp" }
                        ]}
                        label="AMC Type"
                        required
                        isStarRequired
                        errorMsg="AMC Type is required"
                        getIdValue={(val) => {
                            const newAmc = val.id;
                            handleAmcTypeChange(index, val.id)
                        }}
                        disabled={formData.contract_type=='7'}
                        value={
                          formData.contract_type == '7'
                          ? ''
                          :(formData?.gate_data?.[index]?.amc=='nonComp')?'Non - Comp':
                          (formData?.gate_data?.[index]?.amc=='comp')?'Comprehensive':''
                      }
                  />
                </div>
                {/* Price Field */}
                <div className="col-md-3 col-sm-3">
                    <ConstantInput
                        label={(formData?.contract_type=='7')?"Monthly Price":"Monthly Hardware price"}
                        type="number"
                        required
                        value={
                          formData?.gate_data?.[index]?.hardware_price
                        }
                        fullWidth
                        min={1}
                        handleChange={(val) => handleGateInputChange(index, { hardware_price: val })}
                        className="form-control"
                        style={{ fontWeight: '500' }}
                    />
                </div>
                {/* Software Price Field */}
                <div className="col-md-3 col-sm-3">
                    <ConstantInput
                        label="Monthly Software Price"
                        type="number"
                        required
                        value={
                          formData?.gate_data?.[index]?.software_price
                        }
                        fullWidth
                        min={1}
                        disabled={formData?.contract_type=='7'}
                        handleChange={(val) => handleGateInputChange(index, { software_price: val })}
                        className="form-control"
                        style={{ fontWeight: '500' }}
                    />
                </div>

                {/* Remove Button */}
                <div className="col-md-1 col-sm-1 text-center">
                    <button
                        type="button"
                        onClick={() => removeGate(index)}
                        disabled={gateData.length === 1}
                        className="btn btn-outline-danger btn-sm"
                        title="Remove Gate"
                        style={{ fontSize: '0.9em' }}
                    >
                        <i className="bi bi-trash-fill"></i> Remove
                    </button>
                </div>
            </div>
        ))}

        {/* Row for "Add Gate" Button and "Additional Charges" Field */}
        <div className="row mt-4 d-flex align-items-center">
            <div className="col-md-6 col-sm-6">
                <button type="button" onClick={addGate} className="btn btn-primary w-100">
                    + Add Gate
                </button>
            </div>
            <div className="col-md-3 col-sm-3">
                <ConstantInput
                    label="Additional Charges Remarks"
                    type="text"
                    required
                    value={formData.additional_cost_remarks}
                    fullWidth
                    handleChange={(value) =>
                        setFormData({
                            ...formData,
                            additional_cost_remarks: value,
                        })
                    }
                    className="form-control"
                    style={{ fontWeight: '500' }}
                />
            </div>
            <div className="col-md-3 col-sm-3">
                <ConstantInput
                    label="Additional Charges"
                    type="number"
                    required
                    value={formData.additional_cost || '0'}
                    fullWidth
                    handleChange={(value) =>
                        setFormData({
                            ...formData,
                            additional_cost: value,
                        })
                    }
                    className="form-control"
                    style={{ fontWeight: '500' }}
                />
            </div>
        </div>
        </div>
        </FormSection>
        )
        :
          <div className="alert alert-warning mt-4">
            Please add Payment Terms and Contract Type first to View gate details.
          </div>
        }
        {formData.contract_type=='7' &&
        <FormSection title={'Increment Details'}>
        <div className="row">
        <Loader isLoading={isLoading} />
        <div className="col-5">
          <DropDownInput
            label={localization.typeIncreament}
            data={incrementTypes}
            required={true}
            isStarRequired={true}
            errorMsg={localization.typeIncreament}
            getIdValue={(val) =>{
              setIncreamentData({
                ...increament,
                increament_type: val.id,
                increment_value: val.name,
              });
              }
            }
            value={selectedIncrement}
          />
            
        </div>
        </div>
        
        <div className="row">
         
        {incrementBody()}
       
        </div>
       <br/>
        </FormSection>
}
        <Fragment>
    </Fragment>
    <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
    >
    <div className="text-center">
        {
          isSuccess ? (
            <div className="success">
              <img src={Images?.tick} alt="" />
              </div>
          ):(
            <div className="success">
              <img style={{width:'100px'}} src={Images?.ErrorImg} alt="" />
            </div>
          )
        }
        <h5>{message}</h5>
    </div>
    </ModalPop>
    </Layout>
  );
};

export default RaiseRenewalRequest;
